import { useState } from "react";
import { Link } from "react-router-dom";
import { clinicInfo } from "../data";

export default function BabyerBoern() {
  const [activeTab, setActiveTab] = useState("babyer");

  const babyImg1 = "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/babyer-boern-assens-kiropraktor_1.jpg";
  const babyImg2 = "https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/behandling-kiropraktor_4.png";
  const boernImg1 = "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/unsplash-image-cwomdb93o6m_1.jpg";
  const boernImg2 = "https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/babyer-boern-assens-kiropraktor_2.jpg";

  const babyRaad = [
    { title: "Skift side", desc: "Både når du bærer dit barn og ammer eller giver flaske. Forældre har selv en favoritside, og den kan hurtigt smitte af på barnet. Desuden vil det også forebygge, at man som forældre får problemer med skuldre eller ryg, fordi man altid belaster den samme side." },
    { title: "Mindsk risikoen for fladt/skævt baghoved", desc: "Selv om Sundhedsstyrelsen anbefaler, at babyer sover på ryggen er det vigtigt, at de ligger på siden, når der bliver holdt øje med dem." },
    { title: "Træn at ligge på maven fra starten", desc: "Det er en tommelfingerregel, at babyer skal ligge på ryggen 5 minutter for hver uge, de er. Selvfølgelig fordelt ud over dagen." },
    { title: "Skru ned for udstyret!", desc: "Bæreseler, skråstole og autostole bør ikke benyttes mere end højst nødvendigt, da muskler og skelet endnu ikke er udviklet til at holde denne position. Undgå at holde spædbørn i lodret position, hvor tyngdekraften påvirker rygsøjlen mest." },
    { title: "Undgå at “sjat-amme”", desc: "Det er vigtigt ikke at bruge mælken som en sutteklud. Er barnet ikke nået at blive sultent, spiser det mindre, og får derfor hurtigere brug for mad igen." },
    { title: "Lav øvelser hver dag", desc: "Det er en hyggelig måde at være sammen med barnet på, og er med til at styrke den motoriske udvikling. Vi giver altid øvelser sammen med behandlingen." }
  ];

  const boernRaad = [
    { title: "Skab gode vaner", desc: "Husk, hvem dine børn lærer af. Sunde kostvaner og motion er dit ansvar - ikke dit barns!" },
    { title: "Gentag gentag gentag", desc: "Børn elsker gentagelser, fordi det er sådan de lærer bedst." },
    { title: "Mindsk skærmtiden", desc: "Lad ikke dit barn bruge for meget tid med mobil, tablet og PC." },
    { title: "Hav en holdning til dit barns holdning", desc: "Vær både opmærksom på, hvordan dit barn sidder og står. Det er vigtigt for koordination, at barnet har en stærk kerne." },
    { title: "Vær opmærksom på, at barnet skifter stilling", desc: "Det kan f.eks. være en god idé at ligge på maven og se fjernsyn eller sidde op ad væggen med tablet’en." },
    { title: "Kom ud i naturen!", desc: "Frisk luft og motion er sundt for både børn og voksne." },
    { title: "Vær opmærksom på dit barns syn", desc: "Problemer med synet kan give både motoriske udfordringer, læsevanskeligheder og hovedpine." }
  ];

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      {/* Breadcrumb */}
      <nav className="flex mb-8 text-sm text-brand-600 font-medium">
        <Link to="/" className="hover:text-brand-800">Forside</Link>
        <span className="mx-2">/</span>
        <span className="text-brand-900 font-semibold">Babyer & Børn</span>
      </nav>

      {/* Header & Tabs */}
      <div className="text-left space-y-6 mb-12">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-brand-950">
          Kiropraktor til babyer og børn
        </h1>
        <p className="text-lg text-brand-800 max-w-3xl leading-relaxed">
          Vi tilbyder nænsom, blid og tryg behandling tilpasset dit barns udviklingstrin. Vælg herunder for at læse mere om behandling af spædbørn eller større børn.
        </p>

        {/* Tab Buttons */}
        <div className="flex gap-4 border-b border-brand-100 pb-px">
          <button
            onClick={() => setActiveTab("babyer")}
            className={`pb-4 text-lg font-bold border-b-2 transition-all cursor-pointer ${
              activeTab === "babyer"
                ? "border-brand-600 text-brand-950"
                : "border-transparent text-brand-500 hover:text-brand-800"
            }`}
          >
            Babyer & Spædbørn (0-1 år)
          </button>
          <button
            onClick={() => setActiveTab("boern")}
            className={`pb-4 text-lg font-bold border-b-2 transition-all cursor-pointer ${
              activeTab === "boern"
                ? "border-brand-600 text-brand-950"
                : "border-transparent text-brand-500 hover:text-brand-800"
            }`}
          >
            Større Børn (1-15 år)
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        {/* Main Content Area */}
        <article className="lg:col-span-8 space-y-12 text-left">
          {activeTab === "babyer" ? (
            /* BABY SECTION */
            <div className="space-y-12">
              {/* Hero Image */}
              <div className="overflow-hidden rounded-3xl border border-brand-100 shadow-md">
                <img
                  src={babyImg1}
                  alt="En kiropraktor til babyer og børn"
                  className="w-full h-[400px] object-cover object-center"
                />
              </div>

              {/* Intro */}
              <div className="space-y-6">
                <h2 className="text-2xl sm:text-3xl font-bold text-brand-950">
                  Hvornår skal spædbørn til kiropraktor?
                </h2>
                <p className="text-brand-800 leading-relaxed">
                  Der kan være gode grunde til at gå til kiropraktor med sin baby. En fødsel er en hård start på livet, og mange spædbørn kan allerede her have brug for behandling. Det kan lyde voldsomt med kiropraktik til sin nyfødte baby, men det er oftest en lindrende og rolig oplevelse - også for forældrene.
                </p>
              </div>

              {/* Behandling af babyer */}
              <div className="space-y-6 border-t border-brand-100 pt-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-brand-950">
                  Behandling af babyer på Fyn
                </h2>
                <p className="text-brand-800 leading-relaxed">
                  Det er meget anderledes for en kiropraktor at behandle babyer end voksne.
                </p>
                <p className="text-brand-800 leading-relaxed">
                  For det første, kan vi ikke spørge ind til, hvor det gør ondt - vi kan i hvert fald ikke forvente at få svar. Derfor er det nødvendigt at mærke sig frem til, hvor problemet er og være ekstra opmærksom på barnets reaktion.
                </p>
                <p className="text-brand-800 leading-relaxed">
                  Dit barn er i helt trygge hænder hos Kiropraktisk Klinik Assens. Selve behandlingen er meget blid. Spædbørn er bløde og reagerer tilstrækkeligt på lette tryk og mobilisering. Derudover består en stor del af behandlingen ofte i at give gode råd, tips og tricks til forældrene.
                </p>
                <p className="text-brand-800 leading-relaxed bg-brand-50 p-4 rounded-2xl border border-brand-100 text-sm font-medium">
                  <i className="fa-solid fa-circle-info text-brand-600 mr-2" />
                  Hvis du gerne vil til kiropraktor med din baby, anbefaler vi, at du forsøger at bestille tid til behandlingen på et specifikt tidspunkt af dagen - nemlig hvor der er bedst chance for at din baby er udhvilet og mæt.
                </p>
              </div>

              {/* Gode råd til spædbørn */}
              <div className="space-y-6 border-t border-brand-100 pt-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-brand-950">
                  Kiropraktoren giver gode råd til spædbørn
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {babyRaad.map((raad, idx) => (
                    <div key={idx} className="bg-brand-50/30 p-6 rounded-2xl border border-brand-100/60 space-y-2">
                      <h3 className="font-bold text-brand-900 flex items-center gap-2">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-100 text-brand-700 text-xs font-bold">
                          {idx + 1}
                        </span>
                        {raad.title}
                      </h3>
                      <p className="text-xs text-brand-700 leading-relaxed">{raad.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Klassiske symptomer */}
              <div className="space-y-8 border-t border-brand-100 pt-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-brand-950">
                  Kiropraktik til babyer: Vi giver jer en god oplevelse
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                  <div className="md:col-span-7 space-y-6">
                    <div className="space-y-2">
                      <h3 className="text-lg font-bold text-brand-900">De klassiske symptomer</h3>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Vi kan hjælpe på mange forskellige symptomer. Vi ser oftest babyer med skævt baghoved, C-form, kolik eller problemer med at ligge på maven. Men en kiropraktor kan også hjælpe jer med mange andre ting, som f.eks. hvis barnet har forstoppelse eller søvnproblemer.
                      </p>
                      <p className="text-xs text-red-600 font-semibold bg-red-50 px-3 py-1.5 rounded-lg inline-block">
                        OBS! Vi behandler ikke børn, der har feber på 38+.
                      </p>
                    </div>

                    <div className="space-y-2">
                      <h3 className="text-lg font-bold text-brand-900">Biomekaniske udfordringer ved babyer</h3>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Kiropraktisk behandling kan være godt for mange forskellige ting i barnets yngste år. Hvis din baby ikke vil ligge på maven, er bagud med at trille eller ikke kommer i gang med at kravle, kan det skyldes ledmæssige problematikker. Mange gange kommer de hurtigt efter det, når leddene løsnes, så de ikke længere er begrænset i at bevæge sig.
                      </p>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Det er normalt, at babyer har en favoritside, indtil de er omkring 3 måneder. Men det er vigtigt, at de frivilligt kigger til begge sider. Kraniet er meget blødt og ændrer ret hurtigt form, hvis det kun trykkes fra den ene side. Det bliver hurtigt en ond cirkel. Det er vigtigt at søge behandling og tage kontakt til en kiropraktor, der behandler spædbørn, så snart problemet opdages.
                      </p>
                    </div>

                    <div className="space-y-2">
                      <h3 className="text-lg font-bold text-brand-900">Kolik og kiropraktor</h3>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Kolik defineres som uforklarlig gråd i mere end 3 timer om dagen, i mere end 3 dage om ugen, i mere end 3 uger. Oftest begynder kolik inden for de første 14 dage efter fødslen og går over omkring 3-månedersalderen.
                      </p>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Kan en kiropraktor behandle kolik? Det er svært at vide, hvorfor barnet græder, men ofte kan vi hjælpe med at lindre. Kiropraktik kan være svaret, og typisk vil spædbørn reagere hurtigt på behandlingen, hvis det er det, der skal til.
                      </p>
                    </div>
                  </div>

                  <div className="md:col-span-5 space-y-6">
                    <div className="overflow-hidden rounded-2xl border border-brand-100 shadow-sm aspect-4/3">
                      <img
                        src={babyImg2}
                        alt="Behandling af baby"
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <div className="bg-brand-50 p-6 rounded-2xl border border-brand-100">
                      <h4 className="font-bold text-brand-900 text-sm mb-2">Normale reaktioner på behandling</h4>
                      <p className="text-xs text-brand-700 leading-relaxed">
                        Det er helt normalt, at din baby kan sove mere, være mere pylret eller få øget afføring efter behandlingen ved kiropraktoren.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            /* BOERN SECTION */
            <div className="space-y-12">
              {/* Hero Image */}
              <div className="overflow-hidden rounded-3xl border border-brand-100 shadow-md">
                <img
                  src={boernImg1}
                  alt="Kiropraktik til børn"
                  className="w-full h-[400px] object-cover object-center"
                />
              </div>

              {/* Intro */}
              <div className="space-y-6">
                <h2 className="text-2xl sm:text-3xl font-bold text-brand-950">
                  Kiropraktik til børn
                </h2>
                <p className="text-brand-800 leading-relaxed">
                  Det kan være nødvendigt med kiropraktik til dit barn. Børn skal ikke have ondt. Har dit barn smerter, kan det gå ud over både den motoriske og sociale udvikling. Det er vigtigt, at du reagerer, hvis dit barn klager over eller viser symptomer på smerter, sover dårligt eller er urolig.
                </p>
              </div>

              {/* Børn er ikke små voksne */}
              <div className="space-y-6 border-t border-brand-100 pt-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-brand-950">
                  Børn er ikke små voksne
                </h2>
                <p className="text-brand-800 leading-relaxed">
                  Børns skelet er langt fra forbenet helt, og børn er derfor meget mere “bløde” end voksne. Det er derfor ikke unormalt at gå til kiropraktor. Nogle af ryggens led ser anderledes ud, og bevægeligheden i f.eks. nakken er meget forskellig fra voksne.
                </p>
                <p className="text-brand-800 leading-relaxed">
                  Børns hovedstørrelse er næsten 90 % voksenstørrelse, mens nakken kun er tæt på 75 %. Derfor kommer nakken hurtigt på overarbejde, hvis hovedet hænger frem over en iPad i flere timer.
                </p>
              </div>

              {/* Gode råd til børn */}
              <div className="space-y-6 border-t border-brand-100 pt-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-brand-950">
                  Kiropraktor til børn på Fyn: Gode råd
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {boernRaad.map((raad, idx) => (
                    <div key={idx} className="bg-brand-50/30 p-6 rounded-2xl border border-brand-100/60 space-y-2">
                      <h3 className="font-bold text-brand-900 flex items-center gap-2">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-100 text-brand-700 text-xs font-bold">
                          {idx + 1}
                        </span>
                        {raad.title}
                      </h3>
                      <p className="text-xs text-brand-700 leading-relaxed">{raad.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Børnekiropraktor: Vi giver dit barn en god oplevelse */}
              <div className="space-y-8 border-t border-brand-100 pt-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-brand-950">
                  Børnekiropraktor: Vi giver dit barn en god oplevelse
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                  <div className="md:col-span-7 space-y-6">
                    <div className="space-y-2">
                      <h3 className="text-lg font-bold text-brand-900">Symptomer</h3>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Kiropraktik til dit barn kan afhjælpe alt fra hyperaktivitet til søvnproblemer og hovedpine. Symptomerne kan bunde i mange forskellige ting. Det kan f.eks. skyldes, at barnet falder meget, når det begynder at gå, har vokseværk eller medfødte fejlstillinger. I dag bruger de fleste børn og unge meget tid foran computer, telefon eller tablet, og det kan give udfordringer, som kan være vigtige at komme til livs. Jo tidligere i forløbet, der bliver taget hånd om problemet, desto lettere er det at rette op på.
                      </p>
                      <p className="text-xs text-red-600 font-semibold bg-red-50 px-3 py-1.5 rounded-lg inline-block">
                        Vi behandler alle børn, undtagen dem, der har feber.
                      </p>
                    </div>

                    <div className="space-y-2">
                      <h3 className="text-lg font-bold text-brand-900">Undersøgelse</h3>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        We ved godt, det kan være en udfordring at gå til kiropraktor med børn. Alt efter alder, forsøger vi at lege os gennem undersøgelsen. Det er ikke alle, der er lige samarbejdsvillige, så det kan være en god idé at filme barnet hjemmefra, hvis det f.eks. har motoriske udfordringer.
                      </p>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Som en del af undersøgelsen vurderes barnets udvikling, fin- og grovmotorik, evt. hypermobilitet, benlængdeforskel osv. Er der noget, der skal diskuteres uden barnets tilstedeværelse, kan det være en god idé at ringe og få en snak inden første konsultation.
                      </p>
                    </div>

                    <div className="space-y-2">
                      <h3 className="text-lg font-bold text-brand-900">Behandling af børn</h3>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Børn reagerer ofte hurtigt og godt på kiropraktorbehandling. Ligesom med babyer er det ikke som at behandle “små voksne”. Når du går til kiropraktor med babyer og børn, anvendes andre og mere blide behandlingsteknikker, afhængigt af barnets alder og størrelse. Vi udfører naturligvis aldrig behandling uden først at forberede både barn og forældre på, hvad der skal ske.
                      </p>
                      <p className="text-sm text-brand-800 leading-relaxed">
                        Kiropraktisk behandling af børn under 15 år kræver tilstedeværelse af forælder/værge. Unge over 15 må gerne komme alene og kan selv tage stilling til, om de ønsker behandling. Inden behandlingen gives der samtykke til, at forældre orienteres om behandlingsforløbet.
                      </p>
                    </div>
                  </div>

                  <div className="md:col-span-5 space-y-6">
                    <div className="overflow-hidden rounded-2xl border border-brand-100 shadow-sm aspect-4/3">
                      <img
                        src={boernImg2}
                        alt="Kiropraktor til babyer og børn"
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <div className="bg-brand-50 p-6 rounded-2xl border border-brand-100 text-center">
                      <p className="text-sm text-brand-900 font-semibold mb-3">Har du spørgsmål?</p>
                      <Link
                        to="/kontakt"
                        className="inline-flex w-full items-center justify-center rounded-full bg-brand-600 py-2.5 text-sm font-bold text-white shadow-xs hover:bg-brand-700 transition-colors cursor-pointer"
                      >
                        Kontakt klinikken
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </article>

        {/* Sidebar (4 cols) */}
        <aside className="lg:col-span-4 space-y-8 text-left sticky top-24">
          {/* Booking Card */}
          <div className="rounded-3xl bg-brand-900 text-white p-8 shadow-lg space-y-6">
            <h3 className="text-xl font-bold font-display text-white">Bestil tid i dag</h3>
            <p className="text-sm text-brand-200 leading-relaxed">
              Døjer du med smerter eller nedsat bevægelighed? Bestil en tid online eller ring til os for en uforpligtende snak.
            </p>
            <div className="space-y-4 pt-2">
              <a
                href={clinicInfo.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full items-center justify-center rounded-full bg-white py-3.5 text-sm font-bold text-brand-900 shadow-sm hover:bg-brand-50 transition-all duration-200 hover:scale-102 active:scale-98 cursor-pointer"
              >
                Bestil tid online
              </a>
              <a
                href={`tel:${clinicInfo.phone}`}
                className="flex w-full items-center justify-center rounded-full bg-brand-800 border border-brand-700 py-3.5 text-sm font-bold text-white hover:bg-brand-700 transition-colors cursor-pointer"
              >
                <i className="fa-solid fa-phone mr-2" />
                <span className="whitespace-nowrap">{clinicInfo.phone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4")}</span>
              </a>
            </div>
          </div>

          {/* Opening Hours Card */}
          <div className="rounded-3xl bg-white border border-brand-100 p-8 shadow-xs space-y-6">
            <h3 className="text-lg font-bold font-display text-brand-950 border-b border-brand-100 pb-3">
              Åbningstider
            </h3>
            <div className="space-y-3 text-sm text-brand-800">
              {clinicInfo.openingHours.map((item) => (
                <div key={item.day} className="flex justify-between border-b border-brand-50 pb-1.5">
                  <span>{item.day}</span>
                  <span className="font-semibold text-brand-900">{item.hours}</span>
                </div>
              ))}
              <div className="pt-2 text-xs text-brand-600">
                <p className="font-semibold text-brand-800">Telefontider:</p>
                <p className="mt-1">{clinicInfo.telefontider}</p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
